import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// import clsx from 'clsx';
import React from 'react';
import flatten from 'lodash/flatten';
import { spreadsheet as coreSpreadsheet } from '@industriousapps/excelkits-core';
import ContentLoader from 'react-content-loader';
import useLoaderEditingAttrs from '../internal/useLoaderEditingAttrs';
import { getFlattenedIndexOf } from '@/utils/array';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const {
  cellReferencesToDimensions
} = coreSpreadsheet;
const defaultSelections = [['A1:A3']];

const OverviewLoading = _ref => {
  let {
    widgetId,
    sectionId,
    selections: srcSelections = defaultSelections,
    selectionsStrategy = 'default',
    selectionsLabeled,
    seriesOptions,
    editing = false
  } = _ref;
  const selections = flatten(srcSelections);
  let hasHeaders = selectionsLabeled;
  let dimensions;
  const editingAttrs = useLoaderEditingAttrs(editing);

  if (selectionsStrategy === 'rows') {
    const nestedSelections = Array.isArray(srcSelections[0]) ? srcSelections : [srcSelections];
    const options = seriesOptions[getFlattenedIndexOf(nestedSelections, selections[0])] || {
      selections: selections[0]
    }; // Determine if user set 1st row headers to false

    hasHeaders = options.strong === false ? false : true; // Get widest row length

    const width = selections.reduce((acc, selection) => {
      const selectionWidth = cellReferencesToDimensions(selection).width;
      return selectionWidth > acc ? selectionWidth : acc;
    }, 0);
    dimensions = {
      width,
      height: selections.length
    };
  } else if (selectionsStrategy === 'columns') {
    // Get tallest column height
    const height = selections.reduce((acc, selection) => {
      const selectionHeight = cellReferencesToDimensions(selection).height;
      return selectionHeight > acc ? selectionHeight : acc;
    }, 0);
    dimensions = {
      height,
      width: selections.length
    };
  } else {
    dimensions = cellReferencesToDimensions(selections && selections[0] || defaultSelections[0][0]);
  }

  return /*#__PURE__*/_jsxs("table", _objectSpread(_objectSpread({
    className: styles.table
  }, editingAttrs), {}, {
    children: [hasHeaders && /*#__PURE__*/_jsx("thead", {
      children: /*#__PURE__*/_jsx("tr", {
        className: styles.headerRow,
        children: Array(Math.max(1, dimensions.width)).fill(null).map((_, i) => /*#__PURE__*/_jsx("th", {
          className: styles.headerColumn,
          children: /*#__PURE__*/_jsx(ContentLoader, {
            height: 19,
            style: {
              width: '40px'
            },
            viewBox: "0 0 40 19",
            children: /*#__PURE__*/_jsx("rect", {
              x: "0",
              y: "0",
              width: "40",
              height: "19"
            })
          })
        }, `${widgetId}${sectionId}th-load-${i}`))
      })
    }), /*#__PURE__*/_jsx("tbody", {
      children: Array(Math.max(1, dimensions.height - (hasHeaders ? 1 : 0))).fill(null).map((_, i) => /*#__PURE__*/_jsx("tr", {
        className: styles.bodyRow,
        children: Array(Math.max(1, dimensions.width)).fill(null).map((_, k) => /*#__PURE__*/_jsx("td", {
          className: styles.bodyColumn,
          children: /*#__PURE__*/_jsx(ContentLoader, {
            height: 19,
            style: {
              width: '41px'
            },
            viewBox: "0 0 40 19",
            children: /*#__PURE__*/_jsx("rect", {
              x: "0",
              y: "0",
              width: "40",
              height: "19"
            })
          })
        }, `${widgetId}${sectionId}td-load-${i}${k}`))
      }, `${widgetId}${sectionId}tr-load-${i}`))
    })]
  }));
};

export default OverviewLoading;